import { getDefaultExportFromCjs as r } from "./main53.js";
import { __require as t } from "./main11.js";
var e = t();
const a = /* @__PURE__ */ r(e);
export {
  a as default
};
